import { render } from "./UserItem.vue?vue&type=template&id=e087d312&scoped=true"
import script from "./UserItem.vue?vue&type=script&lang=js"
export * from "./UserItem.vue?vue&type=script&lang=js"

import "./UserItem.vue?vue&type=style&index=0&id=e087d312&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e087d312"]])

export default __exports__